import i18n, { i18n as I18nType } from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { loadTranslations } from '@ts/ui-translations';

export const languageMap = {
  en: 'English',
  es: 'Español',
  fr: 'Français',
  ar: 'عربي',
};

//We need to remove track-ui when we have all the translations in common for the components
export const resources = {
  en: loadTranslations('en', ['common', 'track-ui']),
  es: loadTranslations('es', ['common', 'track-ui']),
  fr: loadTranslations('fr', ['common', 'track-ui']),
  ar: loadTranslations('ar', ['common', 'track-ui']),
};

const i18nInstance: I18nType = i18n.createInstance();

console.log('Track-resources', resources);

i18nInstance
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    resources,
    ns: ['common', 'track-ui'],
    defaultNS: 'common',
    fallbackNS: ['track-ui'],

    /* interpolation: {
      escapeValue: false,
    }, */
  });

export default i18nInstance;
